/**
 * Created by Karan variya on 24/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class DashboardService {
    constructor(
        private httpmanagerService: HttpManagerService,
    ) {
    }
    allDashboard(data): Promise<any> {
        return this.httpmanagerService.HttpPost('sdeshboard/dashboard', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    dailyreport(data): Promise<any> {
        return this.httpmanagerService.HttpPost('sdeshboard/daywisereport', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    daywisecountryreport(data): Promise<any> {
        return this.httpmanagerService.HttpPost('sdeshboard/daywisecountryreport', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    nologin_activeuser_report_backup(): Promise<any> {
        var data = {

        }
        return this.httpmanagerService.HttpPost('sdeshboard/nologin_activeuser_reportbackup', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    subscriptionreport(data): Promise<any> {
        return this.httpmanagerService.HttpPost('sdeshboard/subscriptionreport', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    // sendcheckinNotification(countrygroupId): Promise<any> {
    //     return this.httpmanagerService.HttpGet('sdeshboard/sendcheckinnotification', countrygroupId).then(data => {
    //         return data;
    //     })
    // }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/dashboard/dashboard.service.ts